import React from 'react';
import { SmartLinkFormThemeFieldProps } from './SmartLinkFormThemeField.props';

/**
 * Web and Electron pick the page theme in the Creator rail, beside the live
 * preview, so the Customize form does not repeat it.
 *
 * The native app has no rail, so the .native sibling still renders the
 * selector. The theme stays in the form state either way: the submit replaces
 * it, and dropping it would reset the page to the default theme.
 */
export const SmartLinkFormThemeField: React.FC<SmartLinkFormThemeFieldProps> = () => null;
